import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

/**
 * Секция страницы настроек: заголовок (и пояснение) в шапке, содержимое ниже. Без заголовка —
 * просто рамка.
 */
export function Card({
  title,
  description,
  children,
  className,
}: {
  title?: string;
  description?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('rounded-lg border border-border bg-card', className)}>
      {title !== undefined && (
        <header className="border-b border-border px-5 py-3.5">
          <h2 className="text-sm font-semibold">{title}</h2>
          {description !== undefined && (
            <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>
          )}
        </header>
      )}
      <div className="space-y-4 p-5">{children}</div>
    </section>
  );
}
